import { orders, jobDetail, device } from 'shared/constants/api';
import { apiCall } from 'core/api/API';
import { getFormattedDuid } from 'shared/utilities/general';
import moment from 'moment';

export const decorateOrder = ({ orderFromAPI }) => {
  (orderFromAPI.searchableCreated = orderFromAPI.created
    ? moment(orderFromAPI.created).format('MMMM Do YYYY, h:mm:ss a')
    : '-'),
    (orderFromAPI.searchableDevices = orderFromAPI.devices ? orderFromAPI.devices : '-'),
    (orderFromAPI.searchableEndDate = orderFromAPI.end_date
      ? moment(orderFromAPI.end_date).format('MMMM Do YYYY, h:mm:ss a')
      : '-'),
    (orderFromAPI.searchableGracePeriodEndDate = orderFromAPI.grace_period_end_date
      ? moment(orderFromAPI.grace_period_end_date).format('MMMM Do YYYY, h:mm:ss a')
      : '-'),
    (orderFromAPI.searchableGsi1Pk = orderFromAPI.gsi_1_pk ? orderFromAPI.gsi_1_pk : '-'),
    (orderFromAPI.searchableGsi1Sk = orderFromAPI.gsi_1_sk ? orderFromAPI.gsi_1_sk : '-'),
    (orderFromAPI.searchableLastUpdated = orderFromAPI.last_updated
      ? moment(orderFromAPI.last_updated).format('MMMM Do YYYY, h:mm:ss a')
      : '-'),
    (orderFromAPI.searchableOrgId = orderFromAPI.organization_id ? orderFromAPI.organization_id : '-'),
    (orderFromAPI.searchablePk = orderFromAPI.pk ? orderFromAPI.pk : '-'),
    (orderFromAPI.searchablePurchase = orderFromAPI.purchase_date
      ? moment(orderFromAPI.purchase_date).format('MMMM Do YYYY, h:mm:ss a')
      : '-'),
    (orderFromAPI.searchableRecordType = orderFromAPI.record_type ? orderFromAPI.record_type : '-'),
    (orderFromAPI.searchableSeatsBasicTotal = orderFromAPI.seats_basic_total ? orderFromAPI.seats_basic_total : '-'),
    (orderFromAPI.searchableSeatsPremiumTotal = orderFromAPI.seats_premium_total
      ? orderFromAPI.seats_premium_total
      : '-'),
    (orderFromAPI.searchableSeatsTotal = orderFromAPI.seats_total ? orderFromAPI.seats_total : '-'),
    (orderFromAPI.searchableStartDate = orderFromAPI.start_date
      ? moment(orderFromAPI.start_date).format('MMMM Do YYYY, h:mm:ss a')
      : '-'),
    (orderFromAPI.searchableSubscriptionId = orderFromAPI.subscription_id ? orderFromAPI.subscription_id : '-'),
    (orderFromAPI.searchableAddons = orderFromAPI.addons ? orderFromAPI.addons : '-'),
    (orderFromAPI.searchableUpdatedByLambda = orderFromAPI.updated_by_lambda ? orderFromAPI.updated_by_lambda : '-'),
    (orderFromAPI.searchableSk = orderFromAPI.s ? orderFromAPI.s : '-');
  return orderFromAPI;
};

export const decorateJobTarget = ({ jobTargetFromAPI }) => {
  const date = new Date(jobTargetFromAPI.queuedAt);
  const formattedDate = moment(date.toLocaleString('en-US')).format('MMMM Do YYYY, h:mm:ss a');

  jobTargetFromAPI.searchableJobName = getFormattedDuid(JSON.parse(JSON.stringify(jobTargetFromAPI.thingName)));
  jobTargetFromAPI.rawVSGID = JSON.parse(JSON.stringify(jobTargetFromAPI.thingName));
  jobTargetFromAPI.searchableStatus = jobTargetFromAPI.status;
  jobTargetFromAPI.searchableQueuedAt = formattedDate;
  jobTargetFromAPI.searchableQueuedAtTooltip = formattedDate;

  return jobTargetFromAPI;
};

export const getJobDetails = async (jobInfo) => {
  const awsAccount = { env: jobInfo.awsAccount };
  return await apiCall({
    endpoint: 'cloudfrontAPI',
    path: `${jobDetail}/${jobInfo.jobId}`,
    queryStringParameters: awsAccount,
    method: 'get',
  });
};

export const getOrders = async (pageSize, lastEvaluatedKey, awsAccount, stack, searchId) => {
  console.log(pageSize, lastEvaluatedKey, awsAccount, stack, searchId);
  let queryStringParameters;
  if (lastEvaluatedKey && awsAccount) {
    queryStringParameters = {
      pageSize: `${pageSize}`,
      organization_id: lastEvaluatedKey.organization_id,
      env: awsAccount,
      tableStackName: stack,
    };
  } else if (!lastEvaluatedKey && awsAccount && stack && searchId) {
    queryStringParameters = {
      pageSize: `${pageSize}`,
      env: awsAccount,
      tableStackName: stack,
      searchId,
    };
  } else if (lastEvaluatedKey) {
    queryStringParameters = {
      pageSize: `${pageSize}`,
      organization_id: lastEvaluatedKey.organization_id,
    };
  }

  return await apiCall({
    endpoint: 'cloudfrontAPI',
    path: orders,
    method: 'get',
    queryStringParameters: queryStringParameters,
  });
};

export const getDeviceJobs = async (deviceId, pageSize, nextToken, awsAccount) => {
  let queryStringParameters;
  if (nextToken && awsAccount) {
    queryStringParameters = {
      page_size: `${pageSize}`,
      next_token: nextToken,
      env: awsAccount,
    };
  } else if (!nextToken && awsAccount) {
    queryStringParameters = { page_size: `${pageSize}`, env: awsAccount };
  } else if (nextToken && !awsAccount) {
    queryStringParameters = { page_size: `${pageSize}`, next_token: nextToken };
  } else if (!nextToken && !awsAccount) {
    queryStringParameters = { page_size: `${pageSize}` };
  }

  return await apiCall({
    endpoint: 'cloudfrontAPI',
    path: `${device}/${deviceId}${jobs}`,
    method: 'get',
    queryStringParameters: queryStringParameters,
  });
};
